<!--
  elcSgnComp.vue ( etc, mblElcsgn06 )
  - 전자서명 완료 페이지
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <!--Header [s]-->
    <Header
      :rtrnAnimInsYn="state.rtrnAnimInsYn"
      :ernpeDivNm="state.ernpeDivNm"
    />
    <!--Header [e]-->
    <!-- Container [s] -->
    <div class="container type_complete">
      <!-- 완료페이지만 : type_complete 클래스 적용 -->
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <div class="finish_wrap">
            <p>
              메리츠화재 모바일 피보험자 전자서명 및 완전판매모니터링이
              완료되었습니다.<br />이용해주셔서 감사합니다.
            </p>
          </div>
          <div class="btn_area">
            <button type="button" class="btn_main" @click="goHome">
              <span>홈으로 이동</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer :rtrnAnimInsYn="state.rtrnAnimInsYn" />
  </div>
</template>

<script>
import { reactive } from 'vue'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'

export default {
  name: 'cmpltSalComp',
  components: {
    Header,
    Footer,
  },
  setup() {
    var state = reactive({
      rtrnAnimInsYn: false,
      mode: process.env.NODE_ENV,
    })

    const goHome = () => {
      let url = ''
      if (state.mode == 'development') {
        url = 'https://mdev.meritzfire.com:16541/main.do'
      } else {
        url = 'https://m.meritzfire.com/main.do'
      }
      location.href = url
    }

    return {
      state,
      goHome,
    }
  },
}
</script>
